import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    get_courses_categories () {
        return axios.get(apiUrl + 'v2/courses/categories')
    },
    get_recommend_courses () {
        return axios.get(apiUrl + 'v2/get_recommend_courses')
    },
    get_courses_content (query) {
        // qeruy: {query: value}
        return axios.get(apiUrl + 'v2/courses', {params: query})

    },
    get_course_content_for_skill_state(query){
        return axios.get(apiUrl + 'v2/courses_for_skill_state', {params: query})
    }
}
